import { Component, OnDestroy } from '@angular/core';
import { RouterModule } from '@angular/router';
import { MainMenuItem, MainMenuService } from '@cr-bytes/primeng-admin-console';
import { distinctUntilChanged, filter, Subscription } from 'rxjs';
import { AuthService } from './services/auth.service';
import { CognitoService } from './services/cognito.service';
import { InfobipSyncService } from './services/infobip-sync.service';

type AppMenuItem = MainMenuItem & {
    command?: (event?: { originalEvent?: Event; item?: AppMenuItem }) => void;
    disabled?: boolean;
    styleClass?: string;
    badgeClass?: string;
};

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    imports: [
        RouterModule
    ]
})
export class AppComponent implements OnDestroy
{
    isLoggingOut = false;
    private readonly authSubscription: Subscription;

    constructor(
        private readonly _mainMenuSvc: MainMenuService,
        private readonly _cognitoService: CognitoService,
        authService: AuthService,
        infobipSyncService: InfobipSyncService
      )
    {
        this.configureMenu();
        this.authSubscription = authService.isAuth$
            .pipe(
                distinctUntilChanged(),
                filter(isAuthenticated => isAuthenticated)
            )
            .subscribe(() => {
                void infobipSyncService.syncIfDue();
            });
    }

    ngOnDestroy(): void {
        this.authSubscription.unsubscribe();
    }

    async onLogout(): Promise<void> {
        if (this.isLoggingOut) {
            return;
        }

        this.isLoggingOut = true;
        this.configureMenu();

        try {
            await this._cognitoService.logOut();
        } finally {
            this.isLoggingOut = false;
            this.configureMenu();
        }
    }

    private configureMenu(): void {
        this._mainMenuSvc.menuItems = [
            {
                label: '',
                items: [
                    {
                        label: 'Home',
                        icon: 'pi pi-fw pi-home',
                        routerLink: ['/home']
                    },
                    {
                        label: 'Comercios',
                        icon: 'pi pi-fw pi-shop',
                        routerLink: ['/stores']
                    },
                    {
                        label: 'Planes',
                        icon: 'pi pi-fw pi-shopping-bag',
                        routerLink: ['/subscriptions']
                    },
                    {
                        label: 'AI Training Workspace',
                        icon: 'pi pi-fw pi-android',
                        items: [
                            {
                                label: 'AI Training',
                                routerLink: ['/ai-training-workspace']
                            },
                            {
                                label: 'Agent Configs',
                                routerLink: ['/ai-training-workspace/agent-configs']
                            }
                        ]
                    },
                    {
                        label: 'Agent Simulator',
                        icon: 'pi pi-fw pi-android',
                        routerLink: ['/agent-simulator']
                    },
                    {
                        label: 'Reports',
                        icon: 'pi pi-fw pi-chart-bar',
                        items: [
                            {
                                label: 'Reporte de agentes',
                                routerLink: ['/reports/agents']
                            },
                            {
                                label: 'Consumo y facturación Infobip',
                                routerLink: ['/reports/infobip']
                            }
                        ]
                    },
                    {
                        label: 'Pagos',
                        icon: 'pi pi-fw pi-receipt',
                        routerLink: ['/payments']
                    },
                    {
                        label: this.isLoggingOut ? 'Cerrando sesión...' : 'Cerrar sesión',
                        icon: this.isLoggingOut ? 'pi pi-fw pi-spin pi-spinner' : 'pi pi-fw pi-sign-out',
                        command: () => void this.onLogout(),
                        disabled: this.isLoggingOut,
                        styleClass: 'sidebar-logout-link',
                        badgeClass: 'sidebar-logout-item'
                    }
                ]
            }
        ] as AppMenuItem[];
    }
}

